import React, {Component} from 'react';
import {Modal,Button,FormControl,FormGroup,ControlLabel,Form} from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import {Checkbox} from 'react-icheck'
import Select from 'react-select'
import HrStore  from '../../../stores/HrStore';
import * as _ from 'lodash'
import './tabledetail.css'
var NotificationSystem = require('react-notification-system');



class SlipTableHiddenFieldModal extends Component {
  constructor(...args){
    super(...args)
    this.state = {loading:true,cdValue:[],ciValue:[],hiddenField:[],table_key_field:{employee_info:[],income:[],deduction:[],custom_deduction:[],custom_income:[],other_info:[]},table_key_name:{}}
  }

  componentDidMount(){
    this._notificationSystem = this.refs.notificationSystem;
  }

  componentWillReceiveProps(newProps){
    if(newProps.show && newProps.show!==this.props.show){
      this.setState({hiddenField:newProps.hiddenField})
    }
  }

  loadData(){
    let {ciValue,cdValue} = this.state
    HrStore.loadConfigHrTable(this.props.emType,(result)=>{
      cdValue = result.data.table_key_field.custom_deduction.map((item,index)=>{
        let multi = JSON.parse(item)
        return multi.map((label)=>{
          return {label:label,value:label}
        })        
      })
      ciValue = result.data.table_key_field.custom_income.map((item,index)=>{
        let multi = JSON.parse(item)
        return multi.map((label)=>{
          return {label:label,value:label}
        })        
      })
      this.setState({loading:false,cdValue:cdValue,ciValue:ciValue,hidden_key_field:result.data.hidden_key_field,hidden_key_field_print:result.data.hidden_key_field_print,table_key_field:result.data.table_key_field,table_key_name:result.data.table_key_name})
    })
  }

  onSave(){    
    const {hidden_key_field,hidden_key_field_print} = this.state
    HrStore.saveConfigHrTable(this.props.emType,_.pick(this.state, ['table_key_field','hidden_key_field','hidden_key_field_print','table_key_name']),(result)=>{
      if (result.status==='OK') {
          this._notificationSystem.addNotification({
              title: 'แจ้งเตือน',
              message: 'บันทึกรายการสำเร็จ',
              level: 'info',
              position: 'tc'
          });
          if(this.props.onChange!==undefined){
            let item = {table:hidden_key_field,print:hidden_key_field_print}
            this.props.onChange(item)
          }
      }
    },()=>{
        this._notificationSystem.addNotification({
            title: 'แจ้งเตือน',
            message: 'บันทึกรายการไม่สำเร็จ',
            level: 'error',
            position: 'tc'
        });
    })
  }

  onCheckChange(key,field){
    let {hidden_key_field,hidden_key_field_print} = this.state
    if (field==='table') {
      if(hidden_key_field.includes(key)){
          hidden_key_field = hidden_key_field.reduce((rresult,item)=>{
              if(item===key){
                  //Remove
              }else{
                  rresult.push(item)
              }
              return rresult
          },[])        
      }else{
          hidden_key_field.push(key)
      }
    } else if (field==='print') {
      if(hidden_key_field_print.includes(key)){
          hidden_key_field_print = hidden_key_field_print.reduce((rresult,item)=>{
              if(item===key){
                  //Remove
              }else{
                  rresult.push(item)
              }
              return rresult
          },[])        
      }else{
          hidden_key_field_print.push(key)
      }
    }  

    if(this.props.onChange!==undefined){
        
    }
    this.setState({hidden_key_field:hidden_key_field,hidden_key_field_print:hidden_key_field_print})
  }

  onCustomDeductionAdd(){
    let {table_key_field,cdValue} = this.state

    table_key_field.custom_deduction.push("");
    cdValue.push([])

    this.setState({table_key_field:table_key_field,cdValue:cdValue})
  }

  onCustomIncomeAdd(){
    let {table_key_field,ciValue} = this.state

    table_key_field.custom_income.push("");
    ciValue.push([])

    this.setState({table_key_field:table_key_field,ciValue:ciValue})
  }

  onCustomDeductionFieldChange(index,e){
    let {table_key_field} = this.state
    table_key_field.custom_deduction[index] = e.target.value
    this.setState({table_key_field:table_key_field})
  }

  onCustomDeductionFieldBlur(index,e){
    let {table_key_name} = this.state
    table_key_name[e.target.value] = e.target.value
    this.setState({table_key_name:table_key_name})
  }

  onCustomDeductionColumnNameChange(index,e){
    let {table_key_field} = this.state
    table_key_field.custom_deduction[index] = e.target.value
    this.setState({table_key_field:table_key_field})
  }

  onColumnNameChange(key,e){
    let {table_key_name} = this.state
    table_key_name[key] = e.target.value
    this.setState({table_key_name:table_key_name})    
  }

  onRemove(type,index){
    let {table_key_field,cdValue,ciValue} = this.state
    if(type=='deduction'){
      table_key_field.custom_deduction.splice(index,1);
      cdValue.splice(index,1)
    }else{
      table_key_field.custom_income.splice(index,1);
      ciValue.splice(index,1)
    }
    this.setState({table_key_field:table_key_field,cdValue:cdValue,ciValue:ciValue})
  }

  getTableTitle(key){
    const {table_key_name} = this.state
    
    if(table_key_name[key]!==undefined){
      return (<FormControl onChange={this.onColumnNameChange.bind(this,key)} value={table_key_name[key]} />);
    }else{
      return key;
    }
  }

  getBenefitOptions(type,input){
    // if (!input) {
		// 	return Promise.resolve({ options: [] });
		// }

		return HrStore.loadBenefitOptions(type,input)		
		.then((response) => {
			return { options: response.data.data };
		});
  }

  onMultiSelectChange(type,index,e){
    console.log(e);
    const {cdValue,ciValue,table_key_field,table_key_name} = this.state    

    let keyName = '',newKey='';
    if(type=='deduction'){
      cdValue[index] = e
      keyName = table_key_field.custom_deduction[index]
    }else{
      ciValue[index] = e
      keyName = table_key_field.custom_income[index]
    }
    let oldName = "";
    if(table_key_name[keyName]!==undefined){
      oldName = table_key_name[keyName]
      delete table_key_name[keyName]
    }
    //Remove old
    if(type=='deduction'){
      table_key_field.custom_deduction[index] = JSON.stringify(cdValue[index].map((item)=>{
        return item.value
      }))    
      newKey = table_key_field.custom_deduction[index]
    }else{
      table_key_field.custom_income[index] = JSON.stringify(ciValue[index].map((item)=>{
        return item.value
      }))    
      newKey = table_key_field.custom_income[index]
    }
    table_key_name[newKey] = oldName    

    this.setState({cdValue:cdValue,ciValue:ciValue,table_key_field:table_key_field,table_key_name:table_key_name})    
  }

  renderMultiSelect(showType,index,key){
    const {cdValue} = this.state
    return (
      <Select.AsyncCreatable
            multi={true}
            clearable={false}
            value={cdValue[index]} 
            placeholder='พิมพ์ชื่อ...'
            onChange={this.onMultiSelectChange.bind(this,showType,index)}             
            valueKey="value" 
            labelKey="label" 
            loadOptions={this.getBenefitOptions.bind(this,showType)} 
            backspaceRemoves={false}         
            
        />
    )
  }

  renderTableSection(column_info,showInput=false,showType=''){
    const {hidden_key_field,hidden_key_field_print} = this.state
    return Object.keys(column_info).map((index)=>{    
      let key = column_info[index]                  
      return (                          
        <tr key={index} className='text-center' >
          <td className='text-center'>
            <Checkbox
                onChange={this.onCheckChange.bind(this, column_info[index], 'table')}
                checked={!hidden_key_field.includes(column_info[index])}
                checkboxClass="icheckbox_square-blue"
                increaseArea="20%"
                label=""
                />                               
          </td>
          <td className='text-center'>
            <Checkbox
                onChange={this.onCheckChange.bind(this, column_info[index], 'print')}
                checked={!hidden_key_field_print.includes(column_info[index])}
                checkboxClass="icheckbox_square-blue"
                increaseArea="20%"
                label=""
                />                               
          </td>
          <td>{column_info[index]}</td>
          <td>{this.getTableTitle(key)}</td>
          <td>{showInput?(<div>{this.renderMultiSelect(showType,index,key)}</div>):''}</td>
          <td>{showInput?(<Button bsStyle='danger' onClick={this.onRemove.bind(this,showType,index)}><FontAwesome name='trash'/></Button>):''}</td>
        </tr>
      )
    })  
  }
  
  renderTable(){
      let {table_key_field} = this.state
      return (
          <table className='table table-responsive table-input-border-none table-bordered-solid table-hover config-hr-table' >
            <thead>
                <tr>
                    <th colSpan={2} className='text-center'>แสดง</th>
                    <th rowSpan={2} className='text-center' style={{width:'220px'}}>ชื่อ key-field</th>
                    <th rowSpan={2} style={{width:'250px'}}>ชื่อคอลัมน์</th>
                    <th rowSpan={2} className='text-center'>ค่าในสลิป</th>
                    <th rowSpan={2} className='text-center' style={{width:'65px'}}>ลบ</th>
                </tr>
                <tr>
                  <th style={{width:'100px'}} className='text-center'>หน้าตาราง</th>
                  <th style={{width:'100px'}} className='text-center'>หน้าพิมพ์</th>
                </tr>  
            </thead>
            <tbody>
                <tr className='row-section'>
                  <td colSpan={6}>ข้อมูลพนักงาน</td>
                </tr>                
                {this.renderTableSection(table_key_field.employee_info)}
                <tr className='row-section'>
                  <td colSpan={6}>รายรับ</td>
                </tr>                
                {this.renderTableSection(table_key_field.income)}
                {this.renderTableSection(table_key_field.custom_income,true,'income')}
                <tr className='text-center'>
                  <td colSpan={6}><Button bsStyle='primary' onClick={this.onCustomIncomeAdd.bind(this)}><FontAwesome name='plus'/>เพิ่ม Column รายรับเอง</Button></td>
                </tr>                 
                <tr className='row-section'>
                  <td colSpan={6}>รายจ่าย</td>
                </tr>                
                {this.renderTableSection(table_key_field.deduction)}
                {this.renderTableSection(table_key_field.custom_deduction,true,'deduction')}
                <tr className='text-center'>
                  <td colSpan={6}><Button bsStyle='primary' onClick={this.onCustomDeductionAdd.bind(this)}><FontAwesome name='plus'/>เพิ่ม Column รายจ่ายเอง</Button></td>
                </tr> 
                <tr className='row-section'>
                  <td colSpan={6}>ข้อมูลอื่นๆ</td>
                </tr>                
                {this.renderTableSection(table_key_field.other_info)}                
            </tbody>
          </table>
      )
  }

  render(){
    let {show} = this.props
    let {loading} = this.state
    
    return (
      <div>
        <Modal show={show} onShow={this.loadData.bind(this)} enforceFocus={false} onHide={this.props.onHide} dialogClassName="midwidth-dialog">
          <Modal.Header closeButton>
            <Modal.Title>{'แสดงผลคอลัมน์'}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {loading?(<div>กำลังดึงข้อมูล...</div>):this.renderTable()}
            
          </Modal.Body>
          <Modal.Footer>
              <Button bsStyle='primary' onClick={this.onSave.bind(this)}><FontAwesome name='save'/> บันทึก</Button>
              <Button onClick={this.props.onHide}><FontAwesome name='close'/> ปิด</Button>
          </Modal.Footer>        
        </Modal>
        <NotificationSystem ref="notificationSystem" />
      </div>
    )
  }
}

SlipTableHiddenFieldModal.defaultProps = {  
  show : false,
  hiddenField:[]
}

export default SlipTableHiddenFieldModal



// WEBPACK FOOTER //
// ./src/view/hr/slip/SlipTableHiddenFieldModal.js